import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            关于木瓜影视，你想知道的都在这里
          </p>
          <div className="mt-8 space-y-3">
            {faqData.map((item) => (
              <div
                key={item.id}
                className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
              >
                <button
                  onClick={() => setOpenId(openId === item.id ? 0 : item.id)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading pr-4">
                    {item.q}
                  </h3>
                  <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openId === item.id ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                  </span>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openId === item.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}